import i18next from 'i18next';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import { formatNumberForExport } from '../../common/utils';
import { makeXLS } from '@commons/utils/makeXLS';

export const generateExport = (productTableData, currentPeriod, previousPeriod) => {
  // Prepare headers
  const headers = [
    i18next.t('GENERAL.NAME'),
    i18next.t('GENERAL.CATEGORY'),
    `${i18next.t('ANALYSIS.PERFORMANCE.PRODUCT_UNITS_SOLD')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.PRODUCT_UNITS_SOLD')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('GENERAL.TURNOVER_EX_TAX')} (${i18next.t('ANALYSIS.PERFORMANCE.CURRENT_PERIOD')})`,
    `${i18next.t('GENERAL.TURNOVER_EX_TAX')} (${i18next.t('ANALYSIS.PERFORMANCE.CURRENT_PERIOD')})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.MIX')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.MIX')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
  ];

  // Prepare data rows
  const data = productTableData.map((row) => [
    row.name,
    row.category,
    formatNumberForExport(row.units?.current),
    formatNumberForExport(row.units?.previous),
    formatNumberForExport(row.turnoverExcludingTaxes?.current),
    formatNumberForExport(row.turnoverExcludingTaxes?.previous),
    formatNumberForExport(row.mix?.current),
    formatNumberForExport(row.mix?.previous),
  ]);

  // Create sheet
  const sheet = {
    title: i18next.t('ANALYSIS.PERFORMANCE.PRODUCT_GRID_TITLE'),
    headers,
    data,
  };

  // Generate Excel file
  const fileName = `${i18next.t(
    'ANALYSIS.PERFORMANCE.PRODUCT_GRID_TITLE',
  )} - ${currentPeriod.startDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} - ${currentPeriod.endDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} VS ${previousPeriod.startDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} - ${previousPeriod.endDate.format(DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR)}`;
  makeXLS(fileName, [sheet]);
};
